/* eslint-disable */
import weui from "weui.js/dist/weui";
import router from './../router';

export async function makeSureAsync(it, methods, param) {
    await it[methods](...param)
}
/**
 * 处理BoSolution为用户数据，在只拥有订单编号的情况下，这意味着数据已经是非常标准的solution的数据结构了
 * @param orderId 订单ID
 * @param euId 指定EU的Id
 * @return {userData}
 */
export async function getSolutionInfoByOrderId(orderId, euId) {
    weui.loading('正在加载数据')
    console.log(orderId, euId)
    let userData = {}
    let sku = {}
    let skus = []
    let solutionAll = null
    await gcapi('getWaitPayOrderInfoByOrderId', orderId)
        .then(res => {
        solutionAll = JSON.parse(res.body.result.solutionJson)
        })
    userData = boSolution(solutionAll, euId)
    await gcapi('getProteomicsBasicData', '').then(res => {
        if (res.body.result) {
            userData.euTemplates = JSON.parse(res.data.result.euTemplates)
            userData.puTemplates = JSON.parse(res.data.result.puTemplates)
            userData.specPuTemplates = JSON.parse(res.data.result.specPuTemplates)
            skus = res.body.result.proteomicsSku.sort(function (a, b) {
                return  a.sortOrder - b.sortOrder
            })
            sku = skus.filter(v => v.id === userData.currSkuId)[0]
            if (!sku || (sku.length <= 0 || JSON.stringify(sku) === '{}')) {
                weui.loading().hide()
                weui.dialog({
                    title: '无法查看/购买!',
                    content: '该商品无法查看/购买，请重新选购',
                    buttons: [
                        {
                            label: '返回上一页',
                            type: 'primary',
                            onClick: function () {
                                router.back()
                            }
                        }
                    ],
                })
                // weui.alert("该商品已下架，不再支持购买")
            }
            console.log('userData', userData)
            userData.currSku = sku
            console.log(sku, 'shjhsa', userData.currSku)
            userData.singleMeteData = filterMeteData(sku,
                ['paraReturnMaterial', 'paraRemoveHAProtein', 'paraConstructionTech', 'paraBioAnalysis', 'sampleCategory'],
                [71003, 71004, 71005, 71006, 71008])
            userData.singleMeteData.specCategorySuper = filterMeteData(undefined, [getCategorySuperId(userData.singleMeteData.sampleCategory.extraValue)], 71007)[0]
            userData.singleMeteData.specCategorySuperIndex = getMeteDataSelfIndex(userData.singleMeteData.specCategorySuper.dictKey, 71007)
            userData.singleMeteData.sampleCategoryIndex = getMeteDataSelfIndex(userData.singleMeteData.sampleCategory.dictKey, 71008)
            userData.singleMeteData.paraRemoveHAProteinIndex = getMeteDataSelfIndex(userData.singleMeteData.paraRemoveHAProtein.dictKey, 71004)
            userData.singleMeteData.paraConstructionTechIndex = getMeteDataSelfIndex(userData.singleMeteData.paraConstructionTech.dictKey, 71005)
            userData.singleMeteData.paraBioAnalysisIndex = getMeteDataSelfIndex(userData.singleMeteData.paraBioAnalysis.dictKey, 71006)
            console.log(skus, 'sku')
        } else {
            $.toast('请求sku失败，请刷新页面或联系客服')
        }
        console.log(res.body.result.proteomicsSku, 'sku')
    })
    // 获取当前EU的sku【0】参加的活动
    let data = skus.filter(v => v.eu1 === userData.currEu)[0]
    data = data.eu1_Pus.filter(v => v.includes('SPEC') === false)
    await gcapi('getServiceProductPromotions', data).then(res => {
        if (res.data.code === 0) {
            if (res.data.result.length > 0) {
                userData.promotion = res.data.result[0]
            } else {
                userData.promotion = []
            }
        }
    })
    weui.loading('正在加载数据').hide()
    return userData
}
/**
 * 处理BoSolution为用户数据，在需要从购物车取数据的情况下
 * @param customerNo 客户信息
 * @param itemId 指定购物车里的某一服务类产品的Id
 * @return {userData}
 */
export async function getSolutionInfoByCartItemId(customerNo, itemId) {
    weui.loading('正在加载数据')
    console.log(itemId)
    let userData = {}
    let sku = {}
    let skus = []
    let solutionAll
    let oldCartContent
    let cartData
    await gcapi('getNonSalesforceShoppingCart', customerNo)
        .then(res => {
            let cart
            // DB中无购物车记录或者记录为空{}
            if (!res.body.result || !res.body.result.cartContent || res.body.result.cartContent === '{}') {
                cart = '{}'
            }
            else {
                cart = res.body.result.cartContent
                oldCartContent = JSON.parse(cart)
                cartData = JSON.parse(cart)[itemId]
                solutionAll = cartData.allData.boSolution
                solutionAll.diseaseDirection = cartData.diseaseDirectionId
                solutionAll.diseaseName = cartData.diseaseDirectionName
                solutionAll.children[0].briefInfoDetail = cartData.userLabel
                solutionAll.children[0].skuId = cartData.allData.currSkuId
                console.log(solutionAll, '---------------------------------------------------------E><>>>>>>>>>>>>>>')
            }
        })
    userData = boSolution(solutionAll, solutionAll.children[0].id)
    userData.deliveryTime = cartData.allData.deliveryTime
    await gcapi('getProteomicsBasicData', '').then(res => {
        if (res.body.result) {
            userData.euTemplates = JSON.parse(res.data.result.euTemplates)
            userData.puTemplates = JSON.parse(res.data.result.puTemplates)
            userData.specPuTemplates = JSON.parse(res.data.result.specPuTemplates)
            skus = res.body.result.proteomicsSku.sort(function (a, b) {
                return  a.sortOrder - b.sortOrder
            })
            sku = skus.filter(v => v.id === userData.currSkuId)[0]
            if (!sku || (sku.length <= 0 || JSON.stringify(sku) === '{}')) {
                weui.loading().hide()
                weui.dialog({
                    title: '无法查看/购买!',
                    content: '该商品无法查看/购买，请重新选购',
                    buttons: [
                        {
                            label: '返回上一页',
                            type: 'primary',
                            onClick: function () {
                                router.back()
                            }
                        }
                    ],
                })
                // weui.alert("该商品已下架，不再支持购买")
            }
            userData.currSku = sku
            console.log(sku, 'shjhsa', userData.currSku)
            userData.singleMeteData = filterMeteData(sku,
                ['paraReturnMaterial', 'paraRemoveHAProtein', 'paraConstructionTech', 'paraBioAnalysis', 'sampleCategory'],
                [71003, 71004, 71005, 71006, 71008])
            userData.singleMeteData.specCategorySuper = filterMeteData(undefined, [getCategorySuperId(userData.singleMeteData.sampleCategory.extraValue)], 71007)[0]
            userData.singleMeteData.specCategorySuperIndex = getMeteDataSelfIndex(userData.singleMeteData.specCategorySuper.dictKey, 71007)
            userData.singleMeteData.sampleCategoryIndex = getMeteDataSelfIndex(userData.singleMeteData.sampleCategory.dictKey, 71008)
            userData.singleMeteData.paraRemoveHAProteinIndex = getMeteDataSelfIndex(userData.singleMeteData.paraRemoveHAProtein.dictKey, 71004)
            userData.singleMeteData.paraConstructionTechIndex = getMeteDataSelfIndex(userData.singleMeteData.paraConstructionTech.dictKey, 71005)
            userData.singleMeteData.paraBioAnalysisIndex = getMeteDataSelfIndex(userData.singleMeteData.paraBioAnalysis.dictKey, 71006)
            console.log(skus, 'sku')
        } else {
            $.toast('请求sku失败，请刷新页面或联系客服')
        }
        console.log(res.body.result.proteomicsSku, 'sku')
    })
    // 获取当前EU的sku【0】参加的活动
    let data = skus.filter(v => v.eu1 === userData.currEu)[0]
    data = data.eu1_Pus.filter(v => v.includes('SPEC') === false)
    await gcapi('getServiceProductPromotions', data).then(res => {
        if (res.data.code === 0) {
            if (res.data.result.length > 0) {
                userData.promotion = res.data.result[0]
            } else {
                userData.promotion = []
            }
        }
    })
    userData.oldCartContent = oldCartContent
    weui.loading('正在加载数据').hide()
    return userData
}
/**
 * 处理BoSolution为用户数据，在已经拥有购物车中某一数据的情况下
 * @param cartData 在只拥有
 * @return {userData}
 */
export async function getSolutionInfoByCartItemData(cartData) {
    weui.loading('正在加载数据')
    let userData = {}
    let sku = {}
    let skus = []
    let solutionAll
    solutionAll = cartData.allData.boSolution
    solutionAll.diseaseDirection = cartData.diseaseDirectionId
    solutionAll.diseaseName = cartData.diseaseDirectionName
    solutionAll.children[0].briefInfoDetail = cartData.userLabel
    solutionAll.children[0].skuId = cartData.allData.currSkuId
    userData = boSolution(solutionAll, solutionAll.children[0].id)
    userData.deliveryTime = cartData.allData.deliveryTime
    await gcapi('getProteomicsBasicData', '').then(res => {
        if (res.body.result) {
            userData.euTemplates = JSON.parse(res.data.result.euTemplates)
            userData.puTemplates = JSON.parse(res.data.result.puTemplates)
            userData.specPuTemplates = JSON.parse(res.data.result.specPuTemplates)
            skus = res.body.result.proteomicsSku.sort(function (a, b) {
                return  a.sortOrder - b.sortOrder
            })
            sku = skus.filter(v => v.id === userData.currSkuId)[0]
            if (!sku || (sku.length <= 0 || JSON.stringify(sku) === '{}')) {
                weui.loading().hide()
                weui.dialog({
                    title: '无法查看/购买!',
                    content: '该商品无法查看/购买，请重新选购',
                    buttons: [
                        {
                            label: '返回上一页',
                            type: 'primary',
                            onClick: function () {
                                router.back()
                            }
                        }
                    ],
                })
                // weui.alert("该商品已下架，不再支持购买")
            }
            userData.currSku = sku
            userData.singleMeteData = filterMeteData(sku,
                ['paraReturnMaterial', 'paraRemoveHAProtein', 'paraConstructionTech', 'paraBioAnalysis', 'sampleCategory'],
                [71003, 71004, 71005, 71006, 71008])
            userData.singleMeteData.specCategorySuper = filterMeteData(undefined, [getCategorySuperId(userData.singleMeteData.sampleCategory.extraValue)], 71007)[0]
            userData.singleMeteData.specCategorySuperIndex = getMeteDataSelfIndex(userData.singleMeteData.specCategorySuper.dictKey, 71007)
            userData.singleMeteData.sampleCategoryIndex = getMeteDataSelfIndex(userData.singleMeteData.sampleCategory.dictKey, 71008)
            userData.singleMeteData.paraRemoveHAProteinIndex = getMeteDataSelfIndex(userData.singleMeteData.paraRemoveHAProtein.dictKey, 71004)
            userData.singleMeteData.paraConstructionTechIndex = getMeteDataSelfIndex(userData.singleMeteData.paraConstructionTech.dictKey, 71005)
            userData.singleMeteData.paraBioAnalysisIndex = getMeteDataSelfIndex(userData.singleMeteData.paraBioAnalysis.dictKey, 71006)
            console.log(skus, 'sku')
        } else {
            $.toast('请求sku失败，请刷新页面或联系客服')
        }
        console.log(res.body.result.proteomicsSku, 'sku')
    })
    // 获取当前EU的sku【0】参加的活动
    let data = skus.filter(v => v.eu1 === userData.currEu)[0]
    data = data.eu1_Pus.filter(v => v.includes('SPEC') === false)
    await gcapi('getServiceProductPromotions', data).then(res => {
        if (res.data.code === 0) {
            if (res.data.result.length > 0) {
                userData.promotion = res.data.result[0]
            } else {
                userData.promotion = []
            }
        }
    })
    weui.loading('正在加载数据').hide()
    return userData
}
/**
 * 处理BoSolution为用户数据
 * @param solutionAll 完整方案的（包含多个EU）
 * @param euId 指定EU的Id
 * @return {userData} 基础userData数据，所有其它数据必须在该基础上增加
 */
export function boSolution(solutionAll, euId) {
    let userData = {}
    userData.returnMaterialChecked = deDuplicationArray(solutionAll.subLines, ['northId', 'southId']).indexOf(euId) !== -1
    userData.diseaseDirection = {
        id: solutionAll.diseaseDirection,
        name: solutionAll.diseaseName
    }
    solutionAll.children.some(item => {
        if (item.id === euId) {
            userData.boSolution = Object.assign({}, {children: [item]})
            userData.productInfo = {eu1: item.template.templateNo}
            userData.currEu = item.template.templateNo
            userData.currSkuId = item.skuId
            userData.tax = filterMeteData(undefined, [item.taxId], 61033)[0]
            userData.otherTaxName = item.otherTaxName
            userData.groups = item.groups
            userData.sampleType = item.briefInfoDetail.split('/')[1]
            userData.euTemplate = [item.template]
            if (item.parameterValues.length > 1) {
                userData.controlGroups = []
                item.parameterValues.some(it => {
                    if (it.name === '数据比较分组' || it.name.includes('比较')) {
                        it.value.trim().split('\n').forEach(value => {
                            userData.controlGroups.push(value.split(' VS'))
                        })
                        return true
                    }
                })
            } else {
                userData.controlGroups = []
            }
            if (item.groups) {
                userData.geneSelectionGroup = []
                item.groups[0].parameterValues.some(items => {
                    if (items.name === '基因' || items.values) {
                        items.values.forEach(gene => {
                            userData.geneSelectionGroup.push(
                                {
                                    label: gene.outlineInfo,
                                    geneGUID: gene.nativeId
                                }
                            )
                        })
                        return true
                    }
                })
            }
            console.log(item, 'item')
            return true
        }
    })
    return userData
}
/**
 * @description 快捷获取PRM(046, 1)，shoutgun(048, 0)模板编号
 * @param index 拥有索引后会返回数组索引对应值
 * @return {boolean}
 */
export const specialEuTemplateNo = (index) => {
    let arr = ['EU000048', 'EU000046']
    if (index !== undefined && index !== null !== index !== '') {
        return arr[index]
    } else {
        return arr
    }
}
/**
 * 石蜡样本EU编号
 * @return {string}
 */
export const paraffinEuTemplateNo = () => {
    return 'EU000326'
}
export const getMeteDataSelfIndex = (meteDataDictKey, meteDataTypeId) => {
    let dictionary = emkt.getEmktMetaData().dictionariesMap;
    let ins
    let index = -1
    for (const key in dictionary[meteDataTypeId]){
        index += 1
        if (meteDataDictKey === dictionary[meteDataTypeId][key].dictKey) {
            console.log(dictionary[meteDataTypeId][key])
            ins = index
        }
    }
    return ins
}
/**
 * 过滤元数据
 * @param skus 如果有就是根据sku过滤元数据
 * @param conditional 过滤的条件是[]
 * @param meteDataTypeId 元数据的类型是 [] | Number
 * @param filterKey 过滤的关键字段是 ""
 * @return {{}|*[]|*}
 */
export const filterMeteData = (skus, conditional, meteDataTypeId, filterKey) => {
    let dictionary = emkt.getEmktMetaData().dictionariesMap;
    // console.log(dictionary[71002])//产品分类
    // console.log(dictionary[71003])
    // console.log(dictionary[71004])
    // console.log(dictionary[71005])
    // console.log(dictionary[71006])
    let array = []
    let singleMeteData = {}
    if (skus) {
        if (meteDataTypeId){
            if (meteDataTypeId.length) {
                conditional.forEach((pro, index) => {
                    for (const key in dictionary[meteDataTypeId[index]]){
                        if (skus[pro] === dictionary[meteDataTypeId[index]][key].dictKey) {
                            singleMeteData[pro] = dictionary[meteDataTypeId[index]][key]
                        }
                    }
                })
                // console.log(singleMeteData, 'singleMeteData')
                return singleMeteData
            }
        } else {
            let sku = skus.filter(v => v[filterKey] === conditional)
            return sku
        }
    } else {
        for (const key in dictionary[meteDataTypeId]){
            conditional.forEach(item => {
                if (item === dictionary[meteDataTypeId][key].dictKey) {
                 array.push(dictionary[meteDataTypeId][key])
                }
            })
        }
        // console.log(array, 'dictionary[meteDataTypeId]')
        return array
    }
}
/**
 *
 * @param object 包含重复属性的对象
 * @param property 需要去重的属性
 * @return {*[]}
 */
export const deDuplication = (object, property) => {
    let set = new Set()
    let array = []
    for (let i = 0; i < object.length; i++) {
        set.add(object[i][property])
    }
    set.forEach(item => {
        array.push(item)
    })
    console.log(array, '去重结果')
    return array
}
/**
 *
 * @param array 包含重复属性的数组
 * @param property 需要去重的属性
 * @return {*[]}
 */
const deDuplicationArray = (array, property) => {
    let set = new Set()
    let arr = []
    property.forEach(pro => {
        array.forEach(item => {
            set.add(item[pro])
        })
        set.forEach(item => {
            arr.push(item)
        })
    })
    return arr
}
/**
 * 没啥特别的，但是不能改，如果生信分析的模板变了，这里也变一下
 * @return {string[]}
 */
export const boSignalAnalysisTemplateNo = () => {
    return ['PU000270', 'PU000908', 'PU000909']
}

/**
 * @param {string} extraValue From SysDictionary Of Sample Category
 * @return Integer parentId
 */
export const getCategorySuperId = (extraValue) => {
  return extraValue ? JSON.parse(extraValue).parentId : null
}



// WEBPACK FOOTER //
// ./src/util/templateToUserData.js